import { extractEmailDomain } from '@/lib/validation';

const GHOST_INSPECTOR_PATTERN = /^fronttestcompany-ghostinspector[a-zA-Z0-9]*@email\.ghostinspector\.com$/i;

export function isGhostInspector(email: string) {
  const domain = extractEmailDomain(email);

  return domain === 'email.ghostinspector.com';
}
